import React, {createContext, FC, useEffect, useState, Dispatch, SetStateAction, ReactNode} from 'react'
import {Model, ID} from '@/_metronic/helpers'
import {Product, ProductAvailability} from '../core/_models'
import {Supplier} from '../../suppliers/core/_models'
import {getSuppliersArray} from '../../suppliers/core/_requests'
import {getAvailability, getProduct} from '../core/_requests'

// Définir le type du contexte
type ProductContextType = {
  product?: Product // loaded Product
  setProduct: Dispatch<SetStateAction<Product|undefined>>
  suppliers: Array<Supplier> // Suppliers list
  availability: Array<ProductAvailability> | undefined // Availability list
  fetchAvailability: Function // getAvailabilities list
  setItemForUpdate: Dispatch<SetStateAction<Model | undefined | null>> // open modal SetState
  itemForUpdate?: Model | null //  open modal item to manage
  action?: string // open modal action
  setAction: Dispatch<SetStateAction<string | undefined>> //open modal SetState action
}

const ProductContext = createContext<ProductContextType>({
  suppliers: [],
  availability: undefined,
  itemForUpdate: undefined,
  setItemForUpdate: () => {},
  fetchAvailability: () => {},
  action: undefined,
  setAction: () => {},
  product: undefined,
  setProduct: () => {}
})

type Props = {
  productId: ID
  children: ReactNode
}

const ProductProvider: FC<Props> = ({children, productId}) => {
  const [itemForUpdate, setItemForUpdate] = useState<Model | undefined | null>()
  const [action, setAction] = useState<string | undefined>()
  const [suppliers, setSuppliers] = useState<Array<Supplier>>([])
  const [product, setProduct] = useState<Product|undefined>()
  const [availability, setAvailability] = useState<Array<ProductAvailability>>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const fetchAvailability = async () => {
    try {
      const response = await getAvailability(productId)
      if (response) {
        setAvailability(response)
      }
    } catch (e: any) {
      console.log('Product fetch availability failed', e)
    } finally {
    }
  }

  const init = async () => {
    try {
      setProduct(await getProduct(productId))
      setSuppliers(await getSuppliersArray())
    } catch (e: any) {
      console.log('Product init failed', e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    isLoading && init()
  }, [isLoading])

  if (isLoading) {
    return (<>Loading ...</>)
  }

  if (!isLoading && product === undefined) {
    return (<>No product</>)
  }

  return (
    <ProductContext.Provider value={{
      suppliers,
      itemForUpdate,
      setItemForUpdate,
      availability,
      action,
      setAction,
      fetchAvailability,
      product,
      setProduct
    }}>
      {children}
    </ProductContext.Provider>
  )
}

export {ProductContext, ProductProvider}
